module.exports = __webpack_public_path__ + "static/gallery5-d0454a1c4ccb6b850d5a6c5ebdf89ff7.jpg";